import { getTranslations as getTranslationsRepo } from '../../../data/repositories/translationRepository.js';

export const fetchTranslations = (translationType, refId) => getTranslationsRepo(translationType, refId);
